export type StaticPagePermissionHelpers = {
  customerGroup: any;
  checkItemPermission: (item: any, customerGroup: any) => boolean;
  filterByTags: (items: any[], customerGroup: any) => any[];
};

const mapContentfulImage = (img: any) => ({
  src: img?.fields?.file?.fields?.file?.url || '',
  alt: img?.fields?.description || '',
  link: img?.fields?.link || '',
  imageWidth: img?.fields?.imageWidth || '',
});

const mapContentfulSection = (section: any, permissions?: StaticPagePermissionHelpers) => {
  const f = section?.fields;
  let images = f?.images;

  if (permissions && images?.length) {
    const tagged = permissions.filterByTags(images, permissions.customerGroup) || [];
    images = tagged.filter((img: any) =>
      permissions.checkItemPermission(img, permissions.customerGroup),
    );
  }

  const pdfAllowed =
    !f?.pdfFile ||
    !permissions ||
    permissions.checkItemPermission(f.pdfFile, permissions.customerGroup);

  return {
    id: f?.id,
    title: f?.title,
    subtitle: f?.subtitle,
    subtitlePosition: f?.subtitlePosition,
    content: f?.content,
    displaySectionAsAccordion: f?.displaySectionAsAccordion,
    accordionTitle: f?.accordionTitle,
    tableHeadColor: f?.tableHeadColor,
    tableHeadTextColor: f?.tableHeadTextColor,
    tableBodyColor: f?.tableBodyColor,
    tableBodyTextColor: f?.tableBodyTextColor,
    textContentWidth: f?.textContentWidth,
    imageLayout: f?.imageLayout,
    images: (images || []).map(mapContentfulImage),
    imagePosition: f?.imagePosition,
    imageWidth: f?.imageWidth,
    pdfFile: pdfAllowed ? f?.pdfFile?.fields?.file?.url : undefined,
  };
};

export const staticPageDataMapper = (data: any, permissions?: StaticPagePermissionHelpers) => {
  const pageEntry = data?.data?.dataSource?.items?.[0];
  const fields = pageEntry?.fields;

  let navigationSource = fields?.navigation;
  if (permissions && navigationSource?.length) {
    navigationSource = navigationSource.filter((item: any) =>
      permissions.checkItemPermission(item, permissions.customerGroup),
    );
  }

  let sectionsSource = fields?.sections;
  if (permissions && sectionsSource?.length) {
    sectionsSource = sectionsSource.filter((section: any) =>
      permissions.checkItemPermission(section, permissions.customerGroup),
    );
  }

  return {
    pageTitle: fields?.pageTitle,
    navigationTitle: fields?.navigationTitle,
    navigation:
      navigationSource?.map((item: any) => ({
        id: item?.fields?.id,
        label: item?.fields?.label,
        href: item?.fields?.href,
      })) || [],
    sections: sectionsSource?.map((section: any) => mapContentfulSection(section, permissions)) || [],
  };
};
